import { useEffect, useState } from "react";
import SuperAdminLayout from "../layout/SuperAdminLayout";
import CreateOrganisationModal from "../components/CreateOrganisationModal";
import ModuleAssignmentModal from "../components/ModuleAssignmentModal";
import Toast from "../../shared/components/Toast";

const ToggleSwitch = ({ isActive, onChange }) => (
  <div
    className={`toggle-switch ${isActive ? "toggle-on" : "toggle-off"}`}
    onClick={onChange}
    title={isActive ? "Click to Deactivate" : "Click to Activate"}
  >
    <div className="toggle-thumb" />
  </div>
);

const Organisations = ({ adminName, onLogout }) => {

  const [organisations, setOrganisations]       = useState([]);
  const [loading, setLoading]                   = useState(true);
  const [search, setSearch]                     = useState("");
  const [showModal, setShowModal]               = useState(false);
  const [selectedOrg, setSelectedOrg]           = useState(null);
  const [togglingId, setTogglingId]             = useState(null);
  const [toast, setToast] = useState(null);

  const showToast = (message, type = "success") => setToast({ message, type });

  // ─── Module Assignment ──────────────────────────────────────────────────
  const [showModuleModal, setShowModuleModal]   = useState(false);
  const [moduleOrg, setModuleOrg]               = useState(null);

  // ─── Delete confirmation ────────────────────────────────────────────────
  const [deletingId, setDeletingId]             = useState(null);
  const [confirmDeleteOrg, setConfirmDeleteOrg] = useState(null);

  // BUG FIX 1: Removed stray <button> and duplicate handleAssignClick that
  // was outside JSX and conflicting with the correct handleModuleAssign below.

  useEffect(() => {
    fetchOrganisations();
  }, []);

  const fetchOrganisations = async () => {
    try {
      const response = await fetch(
        `https://brsrapi.digioxide.com/api/superadmin/organisations`,
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("admin_token")
          }
        }
      );
      const data = await response.json();
      setOrganisations(data.organisations || []);
      setLoading(false);
    } catch (error) {
      console.error("Error loading organisations:", error);
      setLoading(false);
    }
  };

  // ─── Edit ────────────────────────────────────────────────────────────────
  const handleEditClick = async (org) => {
    try {
      const response = await fetch(
        `https://brsrapi.digioxide.com/api/superadmin/organisations/${org.org_id}`,
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("admin_token")
          }
        }
      );
      const data = await response.json();
      if (data.success) {
        setSelectedOrg(data.organisation);
        setShowModal(true);
      }
    } catch (error) {
      console.error("Error fetching org details:", error);
    }
  };

  // ─── Create / Update ─────────────────────────────────────────────────────
  const handleCreateOrUpdate = async (formData) => {
    const payload = {
      organisation_name:    formData.organisation_name,
      organisation_cin:                  formData.cin,
      organisation_pan:                  formData.pan,
      address:              formData.address,
      industry:             formData.industry,
      contact_name: formData.contact_name,
      email:        formData.email,
      phone:        formData.phone,
    };
    if (formData.password) payload.password = formData.password;

    const url = selectedOrg
      ? `https://brsrapi.digioxide.com/api/superadmin/organisations/${selectedOrg.org_id}`
      : `https://brsrapi.digioxide.com/api/superadmin/organisations`;
    const method = selectedOrg ? "PUT" : "POST";

    try {
      const response = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + localStorage.getItem("admin_token")
        },
        body: JSON.stringify(payload)
      });
      const data = await response.json();
      if (data.success) {
        setShowModal(false);
        setSelectedOrg(null);
        fetchOrganisations();
        return true;
      }
    } catch (error) {
      console.error("Error saving organisation:", error);
    }
    return false;
  };

  // ─── Toggle status ───────────────────────────────────────────────────────
  const handleToggleStatus = async (org) => {
    setTogglingId(org.org_id);
    try {
      const response = await fetch(
        `https://brsrapi.digioxide.com/api/superadmin/organisations/${org.org_id}/toggle-active`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("admin_token")
          },
          body: JSON.stringify({ is_active: !org.is_active })
        }
      );
      const data = await response.json();
      if (data.success) {
        setOrganisations(prev =>
          prev.map(o =>
            o.org_id === org.org_id ? { ...o, is_active: !org.is_active } : o
          )
        );
      }
    } catch (error) {
      console.error("Error toggling status:", error);
    }
    setTogglingId(null);
  };

  // ─── Delete ──────────────────────────────────────────────────────────────
  const handleDeleteClick = (org) => {
    setConfirmDeleteOrg(org);
  };

  const handleDeleteConfirm = async () => {
  if (!confirmDeleteOrg) return;

  setDeletingId(confirmDeleteOrg.org_id);

  try {
    const response = await fetch(
      `https://brsrapi.digioxide.com/api/superadmin/organisations/${confirmDeleteOrg.org_id}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + localStorage.getItem("admin_token")
        }
      }
    );

    const data = await response.json();

    if (response.status === 200 && data.success) {
      setOrganisations(prev =>
        prev.filter(o => o.org_id !== confirmDeleteOrg.org_id)
      );

      setToast({
        message: "Organisation deleted successfully",
        type: "delete"
      });

    } else {
      setToast({
        message: data.message || "Unable to delete organisation",
        type: "error"
      });
    }

  } catch (error) {
    console.error("Error deleting organisation:", error);

    setToast({
      message: "Something went wrong. Unable to delete organisation",
      type: "error"
    });
  }

  setDeletingId(null);
  setConfirmDeleteOrg(null);
};

  // ─── Module Assignment ───────────────────────────────────────────────────
  const handleModuleAssign = (org) => {
    setModuleOrg(org);
    setShowModuleModal(true);
  };

  // BUG FIX 2: Was using undefined `api.post`. Now uses the correct
  // handleModuleSave with fetch, passing moduleIds (not modules).
  const handleModuleSave = async ({ moduleIds, totalAmount }) => {
    try {
      const response = await fetch(
        `https://brsrapi.digioxide.com/api/superadmin/organisations/${moduleOrg.org_id}/modules-list`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("admin_token")
          },
          body: JSON.stringify({ module_ids: moduleIds, total_amount: totalAmount })
        }
      );
      const data = await response.json();
      console.log("Module assignment response:", data);
    } catch (error) {
      console.error("Error assigning modules:", error);
    }
  };

  const filtered = organisations.filter(org =>
    org.organization_name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <SuperAdminLayout userName={adminName} onLogout={onLogout}>
      <div className="dash-page">

        <div className="page-header">
          <div className="page-title">Organisations</div>
          <div className="page-actions">
            <input
              type="text"
              placeholder="Search organisation..."
              className="search-input"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <button
              className="btn-primary"
              onClick={() => {
                setSelectedOrg(null);
                setShowModal(true);
              }}
            >
              + Add Organisation
            </button>
          </div>
        </div>

        <div className="table-card">
          {loading ? (
            <div className="loading-box">Loading organisations...</div>
          ) : (
            <table className="data-table">
              <thead>
                <tr>
                  <th>Organisation Name</th>
                  <th>Primary Contact</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Status</th>
                  <th>Created</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map(org => (
                  <tr key={org.org_id}>
                    <td>{org.organization_name}</td>
                    <td>{org.primary_contact_name}</td>
                    <td>{org.primary_email}</td>
                    <td>{org.primary_phone}</td>
                    <td>
                      <div className="status-cell">
                        <ToggleSwitch
                          isActive={org.is_active}
                          onChange={() => !togglingId && handleToggleStatus(org)}
                        />
                        <span className={org.is_active ? "status-active" : "status-inactive"}>
                          {togglingId === org.org_id
                            ? "Updating..."
                            : org.is_active ? "Active" : "Inactive"
                          }
                        </span>
                      </div>
                    </td>
                    <td>{new Date(org.created_at).toLocaleDateString()}</td>
                    <td className="actions">
                      {/* Module Assignment */}
                      <button
                        className="btn-sm btn-module"
                        onClick={() => handleModuleAssign(org)}
                        title="Assign Modules"
                      >
                        Assign Modules
                      </button>

                      {/* Edit */}
                      <button
                        className="btn-sm btn-edit"
                        onClick={() => handleEditClick(org)}
                      >
                        Edit
                      </button>

                      {/* Delete */}
                      <button
                        className="btn-sm btn-delete"
                        onClick={() => handleDeleteClick(org)}
                        disabled={deletingId === org.org_id}
                        title="Delete Organisation"
                      >
                        {deletingId === org.org_id ? "..." : "Delete"}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

      </div>

      {/* Create / Edit modal */}
      <CreateOrganisationModal
        isOpen={showModal}
        orgData={selectedOrg}
        onClose={() => {
          setShowModal(false);
          setSelectedOrg(null);
        }}
        onSubmit={handleCreateOrUpdate}
      />

      {/* BUG FIX 3: Was using showModal/selectedOrg (Create modal's state).
          Now correctly uses showModuleModal/moduleOrg and handleModuleSave. */}
      <ModuleAssignmentModal
        isOpen={showModuleModal}
        onClose={() => {
          setShowModuleModal(false);
          setModuleOrg(null);
        }}
        org={moduleOrg}
        onSave={handleModuleSave}
      />

      {/* Inline Delete Confirmation Dialog */}
      {confirmDeleteOrg && (
        <>
          <div className="del-overlay" onClick={(e) => e.target === e.currentTarget && setConfirmDeleteOrg(null)}>
            <div className="del-dialog">
              <p>
                Are you sure you want to delete?<br/>
                This action cannot be undone.
              </p>
              <div className="del-actions">
                <button className="del-btn-cancel" onClick={() => setConfirmDeleteOrg(null)}>Cancel</button>
                <button className="del-btn-confirm" onClick={handleDeleteConfirm}>Delete</button>
              </div>
            </div>
          </div>
        </>
      )}

      {toast && (
      <Toast
        message={toast.message}
        type={toast.type}
        onClose={() => setToast(null)}
      />
    )}
    </SuperAdminLayout>
  );
};

export default Organisations;
